import "./TermsOfService.module.css";
import Header from "@/reusable_sections/Header";
import Terms from "./sections/Terms";
import Footer from "@/reusable_sections/Footer";
export default function TermsOfServicePage() {
  return <div>
      <Header />
      <Terms />
      <Footer />
    </div>;
}